import React from 'react';
import { motion } from 'framer-motion';
export function FinalCTASection() {
  return <section className="w-full py-10 md:py-16 px-4 bg-[#F3E8F0] text-center border-t border-[#E8D8E0]" data-id="element-53">
      <div className="max-w-4xl mx-auto" data-id="element-54">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-5xl font-bold text-brand-text-primary mb-4 md:mb-6" data-id="element-55">
          Tu cuerpo lleva 28 días esperando esta información.
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="text-xl text-brand-text-muted mb-6 md:mb-10 max-w-2xl mx-auto" data-id="element-56">
          Podés seguir haciendo lo mismo de siempre. O podés tomar hoy la única
          decisión que trabaja CON tu biología, no contra ella.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} data-id="element-57">
          <button onClick={() => {
          if ((window as any).fbq) (window as any).fbq('track', 'AddToCart', {
            content_name: 'Código Hormonal + Bonos',
            value: 17990,
            currency: 'ARS'
          });
          window.open('https://ebookpromax.com/cart/46565326291102:1', '_blank');
        }} className="neon-cta bg-brand-orange hover:bg-brand-orange-hover text-white font-bold text-xl md:text-3xl py-6 px-8 md:px-16 rounded-full transition-all duration-300 uppercase tracking-wide transform hover:scale-105" data-id="element-58">
            <span className="cta-text-iridescent" data-id="element-59">
              EMPEZAR MI TRANSFORMACIÓN DE 28 DÍAS
            </span>
          </button>
        </motion.div>
      </div>
    </section>;
}